import React from "react";

import { intercomAppKey } from "../../config";
import { showMessenger } from "../../utils/intercom";
import { IconButton } from "../common/IconButton";
import * as styles from "./SidebarContent.scss";

const Intercom: React.FC = () => {
    if (!intercomAppKey) {
        return null;
    }

    return (
        <IconButton
            data-testid="need-help"
            className={styles.help}
            icon="help"
            onClick={showMessenger}
        >
            Need help?
        </IconButton>
    );
};

export default Intercom;
